/*
 * @Author: bbqin
 * @Date: 2022-10-21 09:42:32
 * @LastEditTime: 2023-05-15 16:01:41
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\adapter\formCard\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import Field from './field';
import View from './view';
import { getSysFieldid } from '@platform/api';

require('./index.less');

class FromCard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { code } = this.props;

        return <div
            className="form-card-setting-container"
            fieldid={getSysFieldid(`${code}_setting_area`)}
        >
            <Field {...this.props} />
            <View {...this.props} />
        </div>;
    }
}

export default FromCard;